// extracted by mini-css-extract-plugin
module.exports = {"TitleBar":"TitleBar__TitleBar___2TzX_","BackButton":"TitleBar__BackButton___Nkf6-","BackBtnWrapper":"TitleBar__BackBtnWrapper___2xuvO"};